export default __webpack_public_path__ + "aef00ccb4a5fd6f7cbea6df39c6dbda9.svg";